var render = function render(){
  var _vm$events, _vm$events$currentPag, _vm$events2, _vm$events3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "id": "table",
      "items": (_vm$events = _vm.events) === null || _vm$events === void 0 ? void 0 : _vm$events.items,
      "per-page": _vm.pageSize,
      "fields": _vm.getTableFields,
      "busy": _vm.loading,
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-primary my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle",
          attrs: {
            "variant": "primary"
          }
        }), _c('strong', [_vm._v(_vm._s(_vm.$t('loading')))])], 1)];
      },
      proxy: true
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('div', {
          staticClass: "little-circle",
          style: {
            'background-color': row.item.deletedAt ? 'red' : 'green'
          }
        }), _c('span', {
          staticClass: "name"
        }, [_vm._v(" " + _vm._s(row.item.name) + " ")])];
      }
    }, {
      key: "cell(type)",
      fn: function (row) {
        var _row$item$type;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.$t(`dashboard.events.type.${(_row$item$type = row.item.type) !== null && _row$item$type !== void 0 ? _row$item$type : 'NONE'}`)) + " ")])];
      }
    }, {
      key: "cell(createdAt)",
      fn: function (row) {
        var _row$item$createdAt;
        return [_vm._v(" " + _vm._s((_row$item$createdAt = row.item.createdAt) === null || _row$item$createdAt === void 0 ? void 0 : _row$item$createdAt.toLocaleString()) + " ")];
      }
    }, {
      key: "cell(deletedAt)",
      fn: function (row) {
        var _row$item$deletedAt;
        return [_vm._v(" " + _vm._s((_row$item$deletedAt = row.item.deletedAt) === null || _row$item$deletedAt === void 0 ? void 0 : _row$item$deletedAt.toLocaleString()) + " ")];
      }
    }, {
      key: "cell(startDate)",
      fn: function (row) {
        var _row$item$startDate;
        return [_vm._v(" " + _vm._s((_row$item$startDate = row.item.startDate) === null || _row$item$startDate === void 0 ? void 0 : _row$item$startDate.toLocaleDateString()) + " ")];
      }
    }, {
      key: "cell(fullName)",
      fn: function (row) {
        return [row.item.createdBy ? _c('span', [_vm._v(" " + _vm._s(_vm.getCreatedByFullName(row.item.createdBy)) + " ")]) : _vm._e()];
      }
    }])
  })], 1), _c('b-pagination', {
    staticClass: "ml-3",
    attrs: {
      "value": ((_vm$events$currentPag = (_vm$events2 = _vm.events) === null || _vm$events2 === void 0 ? void 0 : _vm$events2.currentPage) !== null && _vm$events$currentPag !== void 0 ? _vm$events$currentPag : 0) + 1,
      "total-rows": (_vm$events3 = _vm.events) === null || _vm$events3 === void 0 ? void 0 : _vm$events3.totalItems,
      "per-page": _vm.pageSize,
      "aria-controls": "table",
      "align": "right",
      "limit": "5",
      "hide-goto-end-buttons": ""
    },
    on: {
      "change": function ($event) {
        return _vm.fetchEvents($event - 1);
      }
    }
  }, [_c('template', {
    slot: "prev-text"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/prev.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + " ")]), _c('template', {
    slot: "next-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('next')) + " "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/next.svg")
    }
  })])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }